class GltheaaCollectionSort extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.gltheaa-collection__sort-toggle');
    this.panel = this.querySelector('.gltheaa-collection__sort-panel');
    this.plusIcon = this.querySelector('.gltheaa-collection__action-icon--plus');
    this.minusIcon = this.querySelector('.gltheaa-collection__action-icon--minus');
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  connectedCallback() {
    if (!this.toggle || !this.panel) return;

    this.toggle.addEventListener('click', () => {
      const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
      this.setOpen(!isOpen);
    });

    this.querySelectorAll('input[name="sort_by"]').forEach((input) => {
      input.addEventListener('change', (event) => {
        this.setOpen(false);
        if (window.GltheaaCollectionFilters) {
          window.GltheaaCollectionFilters.submit(event);
        }
      });
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.setOpen(false);
    }
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.setOpen(false);
    }
  }

  setOpen(isOpen) {
    this.toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    this.panel.hidden = !isOpen;
    this.classList.toggle('is-open', isOpen);
    this.plusIcon?.classList.toggle('hidden', isOpen);
    this.minusIcon?.classList.toggle('hidden', !isOpen);
  }
}

if (!customElements.get('gltheaa-collection-sort')) {
  customElements.define('gltheaa-collection-sort', GltheaaCollectionSort);
}
